module.exports = __webpack_public_path__ + "img/Flag_of_Burkina_Faso.e7755454.svg";